import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { InsuranceClaimRoutingModule } from './insurance-claim-routing.module';
import { InsuranceClaimCreateComponent } from './insurance-claim-create/insurance-claim-create.component';
import { InsuranceClaimEditComponent } from './insurance-claim-edit/insurance-claim-edit.component';
import { InsuranceClaimFormContentComponent } from './shared/insurance-claim-form-content/insurance-claim-form-content.component';
import { SharedModule } from '../../../shared/shared.module';
import { InsuranceClaimDetailsComponent } from './insurance-claim-details/insurance-claim-details.component';
import { InsuranceClaimTabsDetailsComponent } from './insurance-claim-details/insurance-claim-tabs-details/insurance-claim-tabs-details.component';
import { CustomActionsFlowInsuranceClaimComponent } from './insurance-claim-details/custom-actions-flow-insurance-claim/custom-actions-flow-insurance-claim.component';
import { InsuranceClaimRejectReasonContentComponent } from './insurance-claim-reject-reason-content/insurance-claim-reject-reason-content.component';
import { InsuranceClaimDetailsStatusHistoriesComponent } from './insurance-claim-details/insurance-claim-details-tab/insurance-claim-details-status-histories/insurance-claim-details-status-histories.component';
import { InsuranceClaimStatusHistoryEditContentComponent } from './shared/insurance-claim-status-history-edit-content/insurance-claim-status-history-edit-content.component';
import { InsuranceClaimDetailsDocumentsComponent } from './insurance-claim-details/insurance-claim-details-tab/insurance-claim-details-documents/insurance-claim-details-documents.component';
import { InsuranceClaimDetailsAccountMovesComponent } from './insurance-claim-details/insurance-claim-details-tab/insurance-claim-details-account-moves/insurance-claim-details-account-moves.component';

@NgModule({
  declarations: [
    InsuranceClaimCreateComponent,
    InsuranceClaimEditComponent,
    InsuranceClaimFormContentComponent,
    InsuranceClaimDetailsComponent,
    InsuranceClaimTabsDetailsComponent,
    CustomActionsFlowInsuranceClaimComponent,
    InsuranceClaimRejectReasonContentComponent,
    InsuranceClaimDetailsStatusHistoriesComponent,
    InsuranceClaimStatusHistoryEditContentComponent,
    InsuranceClaimDetailsDocumentsComponent,
    InsuranceClaimDetailsAccountMovesComponent,
  ],
  imports: [CommonModule, InsuranceClaimRoutingModule, SharedModule],
})
export class InsuranceClaimModule {}
